import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

/**
 * Captura errores de render del árbol de React (observabilidad, docs/PLAN.md §13).
 * En producción aquí se enviaría el error a un servicio de monitoreo.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <main className="container" style={{ padding: '4rem 1rem', textAlign: 'center' }}>
          <h1>Algo salió mal</h1>
          <p className="text-soft">Por favor recarga la página.</p>
          <a className="btn btn--primary" href="/" style={{ marginTop: '1rem' }}>
            Recargar
          </a>
        </main>
      );
    }
    return this.props.children;
  }
}
